module.exports = __webpack_public_path__ + "img/yyzz.0dc0dce7.jpg";